import React from 'react';
import { StoredMatch } from './types';
import { formatMatchOption } from './helpers';
import LoadingStatus from '@/components/ui/LoadingStatus';

interface MatchSelectProps {
  matches: StoredMatch[];
  teamId: number | null;
  selectedMatchId: number | '';
  processing: boolean;
  onSelectMatch: (matchId: number) => void;
}

const MatchSelect: React.FC<MatchSelectProps> = ({
  matches,
  teamId,
  selectedMatchId,
  processing,
  onSelectMatch,
}) => {
  return (
    <div className="flex items-center gap-2">
      <select
        className="input-field flex-1"
        value={selectedMatchId}
        onChange={(e) => {
          const val = e.target.value;
          if (val) onSelectMatch(Number(val));
        }}
        disabled={processing}
      >
        <option value="">Select a match...</option>
        {matches.map((m) => (
          <option key={m.wyscoutMatchId} value={m.wyscoutMatchId}>
            {formatMatchOption(m, teamId)}
          </option>
        ))}
      </select>
      {processing && (
        <LoadingStatus label="Loading selected match" />
      )}
    </div>
  );
};

export default MatchSelect;
